import { ReactComponent as TooltipIcon } from "svg/question-line.svg";
import { TooltipContainer } from "@outplayed/tooltips";
import classNames from "classnames";
import { SPECS_TO_HERO_TREES } from "lib/classes-and-specs";
import { getHeroTalentIconURL, getIsHealer, getIsTank } from "lib/wowHelpers";
import { tierListColor } from "../TierLists/TierListHelper";

// TWWTODO: For all stats - see how it's set up on WOWBuildsStatSection in WOWBuildsContainer.js
const HeroTalentButton = (props) => {
  const { isActive, onClick, side, heroTreeName, specType, pageType, data } = props;

  const thisHeroData = isActive ? data?.chosenHero : data?.otherHero;

  const statPerSecond = getIsHealer(specType) ? thisHeroData?.hps : thisHeroData?.dps;
  const formattedStatPerSecond = statPerSecond ? (statPerSecond / 1000).toFixed(1).toLocaleString("en-US") : 0;
  const statPerSecondLabel = getIsHealer(specType) ? "HPS" : getIsTank(specType) ? "Tank DPS" : "DPS";
  const statPerSecondTooltip = getIsHealer(specType)
    ? "HPS is the aggregated Healing Per Second score that each Healer spec does in the top rankings of Raid and Mythic+ Dungeons."
    : getIsTank(specType)
    ? "For Tanks we opted to show their aggregated DPS score as a temporary placeholder metric while we search for a more valuable metric that tank players care about."
    : "DPS is the aggregated Damage Per Second score that each DPS spec does in the top rankings of Raid and Mythic+ Dungeons.";
  const modifiedPickrate = thisHeroData?.pickrate ? (Math.round(thisHeroData?.pickrate * 10000) / 100).toFixed(1) : 0;
  const pvpPickrate = thisHeroData?.pickrate?.toFixed(2) ? thisHeroData?.pickrate?.toFixed(2) : "N/A";
  const pvpRating = thisHeroData?.rating ? thisHeroData.rating : "N/A";
  const tierLetter = (thisHeroData?.parses ?? 0) === 0 ? "N/A" : thisHeroData?.tierLetter;

  return (
    <div className={classNames("hero-talent-button-container", { active: isActive })} onClick={() => onClick(side)}>
      <div className="left-container">
        <img src={getHeroTalentIconURL(heroTreeName)} alt={heroTreeName} />
        <div className="middle-container">
          <div className="hero-name">{heroTreeName}</div>
          {pageType !== "Builds" && (
            <div className="parses">
              {pageType === "PvP" ? "Players" : "Parses"}: <strong>{thisHeroData?.parses ?? 0}</strong>
            </div>
          )}
        </div>
      </div>
      <div className="right-container">
        {pageType !== "Builds" && (
          <>
            <div className="stat-container">
              <div className="top-stat" style={{ color: isActive ? tierListColor(thisHeroData.tierLetter) : "white" }}>
                {tierLetter ?? "N/A"}
              </div>
              <div className="bottom-stat">
                Tier
                <TooltipContainer tooltipInfo="We calculate spec tier using a combination of their aggregated DPS or HPS score and how often the spec appears in the top rankings of the Raid or Mythic+ dungeons.">
                  <div className="tooltip-container">
                    <TooltipIcon className="tooltip-icon" />
                  </div>
                </TooltipContainer>
              </div>
            </div>
            <div className="stat-container">
              <div className="top-stat">{pageType === "PvP" ? pvpPickrate + "%" : modifiedPickrate + "%"}</div>
              <div className="bottom-stat">
                Popularity
                <TooltipContainer tooltipInfo="Popularity is how often this spec appears in the top rankings of Raid or Mythic+ Dungeons.">
                  <div className="tooltip-container">
                    <TooltipIcon className="tooltip-icon" />
                  </div>
                </TooltipContainer>
              </div>
            </div>
            <div className="stat-container">
              {/* TWWTODO: Replace hardcoded PvP value */}
              <div className="top-stat">{pageType === "PvP" ? pvpRating : formattedStatPerSecond + "K"}</div>
              <div className="bottom-stat">
                {pageType === "PvP" ? "Median Rating" : statPerSecondLabel}
                <TooltipContainer
                  tooltipInfo={
                    pageType === "PvP"
                      ? "The median rating of the selected spec out of all players we're analyzing"
                      : statPerSecondTooltip
                  }
                >
                  <div className="tooltip-container">
                    <TooltipIcon className="tooltip-icon" />
                  </div>
                </TooltipContainer>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const HeroTalentSelector = (props) => {
  const { activeHero, displayClassName, displaySpecName } = props;
  const heroArray = SPECS_TO_HERO_TREES[displayClassName].specs[displaySpecName];

  return (
    <div className="hero-talent-selector-container">
      <HeroTalentButton heroTreeName={heroArray[0]} isActive={activeHero === "left"} side="left" {...props} />
      <HeroTalentButton heroTreeName={heroArray[1]} isActive={activeHero === "right"} side="right" {...props} />
    </div>
  );
};

export default HeroTalentSelector;
